export const ADMIN = "admin";

export const ADMIN_ROUTES = {
    AUTHENTICATION: "/admin/authentication",
    HOME: "/admin",
    INVITATIONS: "/admin/invitations",
    USERS: "/admin/users",
    SUBSCRIPTIONS: "/admin/subscriptions",
};  

